"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IScaleLevel = void 0;
var IScaleLevel;
(function (IScaleLevel) {
    IScaleLevel["Minus6"] = "minus6";
    IScaleLevel["Minus5"] = "minus5";
    IScaleLevel["Minus4"] = "minus4";
    IScaleLevel["Minus3"] = "minus3";
    IScaleLevel["Minus2"] = "minus2";
    IScaleLevel["Minus1"] = "minus1";
    IScaleLevel["Zero"] = "zero";
    IScaleLevel["Plus1"] = "plus1";
    IScaleLevel["Plus2"] = "plus2";
    IScaleLevel["Plus3"] = "plus3";
    IScaleLevel["Plus4"] = "plus4";
    IScaleLevel["Plus5"] = "plus5";
    IScaleLevel["Plus6"] = "plus6";
})(IScaleLevel || (exports.IScaleLevel = IScaleLevel = {}));
//# sourceMappingURL=scale-level.js.map